import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Fragment } from 'react';
import { capitalizeAndSpace } from '../utils/capitalizeAndSpace.ts';
import { DynamicValueSectionItemCell } from './DynamicValueSectionItemCell.tsx';

type DynamicValueSectionItemsProps<T extends object, K extends Extract<keyof T, string> = Extract<keyof T, string>> = {
  item: T;
  props: K[];
  propNameMap?: Record<string, string>;
};

export const DynamicValueSectionItems = <T extends object, K extends Extract<keyof T, string>>({
  item,
  props,
  propNameMap,
}: DynamicValueSectionItemsProps<T, K>) => {
  if (!item) {
    return null;
  }

  const visibleProps = props.filter(key => item[key] != null);
  if (visibleProps.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        padding: 3,
        border: 1,
        borderColor: 'divider',
      }}
    >
      {visibleProps.map((propName, idx) => {
        const isNotLastItem = idx < visibleProps.length - 1;
        const value = item[propName];

        return (
          <Fragment key={String(propName)}>
            <Grid
              container
              sx={{
                padding: 2,
                paddingBottom: 1,
              }}
            >
              <Grid size={6}>
                <Typography data-test={`ad-inventory-dimension-${String(propName)}`} variant="h3">
                  {capitalizeAndSpace(String(propName), propNameMap)}
                </Typography>
              </Grid>

              <Grid size={6}>
                <DynamicValueSectionItemCell value={value} propName={propName} />
              </Grid>
            </Grid>
            {isNotLastItem && (
              <Box
                sx={{
                  paddingLeft: 2,
                  paddingRight: 2,
                }}
              >
                <Divider />
              </Box>
            )}
          </Fragment>
        );
      })}
    </Box>
  );
};
